export class Exam {
  description!: String;
  cfu!: number;
  ssd!: string;
}